import React, { useState, useRef, useEffect } from "react";
import { Link } from 'react-router-dom';
import "./DropdownNew.css"
function DropdownNew2() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
            <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
                <button className = "button-dropdown" onClick={() => setOpen(!open)}>About Us ▼</button>
                {open && (
                <ul
                    style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                backgroundColor: "white",
                                border: "1px solid gray",
                                padding: 0,
                                margin: 0,
                                listStyle: "none",
                                width: "200px",
                                zIndex: 1000,
                            }}
                            >
                            <li>
                              <Link to="/about"  className = "dropdown-link" >About Us</Link></li>
                            <li>
                              <Link to="/contact-us" className = "dropdown-link" >Contact Us</Link></li>
                               <li>
                              <Link to="/events/map" className = "dropdown-link" >  <svg style={{width: "30px",height: "30px"}}xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="rgb(60, 163, 204)">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                             <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                             </svg>Furry Event Map</Link></li>
                              
                              
                </ul>
            )}
        </div>
    
    </div>
    
  );
}

export default DropdownNew2;
